export const DEBUG_MIN_VERSION = '0.6.0';
